var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1585 23.9817L13.7927 14.6159C13.061 15.2744 12.2134 15.7744 11.25 16.1159C10.2866 16.4573 9.31707 16.6281 8.34146 16.6281C6.02439 16.6281 4.05488 15.8232 2.43293 14.2134C0.810976 12.6037 0 10.6403 0 8.32319C0 6.00611 0.804879 4.0427 2.41463 2.43295C4.02439 0.823189 5.98781 0.0183105 8.30488 0.0183105C10.622 0.0183105 12.5915 0.823189 14.2134 2.43295C15.8354 4.0427 16.6463 6.00611 16.6463 8.32319C16.6463 9.32319 16.4695 10.3049 16.1159 11.2683C15.7622 12.2317 15.2561 13.0793 14.5976 13.811L24 23.1403L23.1585 23.9817ZM8.34146 15.4939C10.3659 15.4939 12.0732 14.8049 13.4634 13.4268C14.8537 12.0488 15.5488 10.3476 15.5488 8.32319C15.5488 6.2988 14.8537 4.59148 13.4634 3.20124C12.0732 1.81099 10.3659 1.11587 8.34146 1.11587C6.31707 1.11587 4.60976 1.81099 3.21951 3.20124C1.82927 4.59148 1.13415 6.2988 1.13415 8.32319C1.13415 10.3476 1.82927 12.0488 3.21951 13.4268C4.60976 14.8049 6.31707 15.4939 8.34146 15.4939Z",
    fill: "#5E5E5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.83e9ba7fd3d64656220e6b34dc447cd5.svg";
export { ForwardRef as ReactComponent };